/** Grid-fade fragment shader. */

precision highp float;

#if defined(gridFade_output_fade)
  #define typeHash 0
  #define typeGauss 1

  #ifndef type
    #define type typeHash
  #endif

  #if type == typeGauss
    #define qualityTap5 0
    #define qualityTap9 1
    #define qualityTap13 2

    #ifndef quality
      #define quality qualityTap5
    #endif
  #elif !defined(quality)
    #define quality 3
  #endif

  gridFade_useSamples
  gridFade_useReads_fade

  #ifdef gridFade_splits
    uniform sampler2D gridFade_states[gridFade_splits];
  #else
    uniform sampler2D gridFade_states;
  #endif

  uniform float gridFade_stepNow;
  uniform vec4 gridFade_stateShape;

  uniform float fade;
  uniform float expose;
  uniform float scale;

  uniform vec4 colorLo;
  uniform float dt;

  #if type == typeHash
    uniform float chaos;
  #endif

  varying vec2 gridFade_uv;

  #if type == typeGauss
    const vec2 axis = vec2(1, 0);
    const float passes = 2.0;
  #else
    const float passes = 1.0;
  #endif

  #if type == typeGauss
    #if quality > qualityTap9
      #pragma glslify: blur = require(glsl-fast-gaussian-blur/13);
    #elif quality > qualityTap5
      #pragma glslify: blur = require(glsl-fast-gaussian-blur/9);
    #elif quality > qualityHash
      #pragma glslify: blur = require(glsl-fast-gaussian-blur/5);
    #endif
  #else
    vec4 sampleFade(vec2 uv) {
      gridFade_tapState(uv);

      return gridFade_data[gridFade_reads_fade_fade].gridFade_channels_fade;
    }

    vec3 sampleHash(vec2 uv) { return sampleFade(uv).rgb; }

    #pragma glslify: blur = require(glsl-hash-blur, sample = sampleHash, iterations = quality);
  #endif

  #pragma glslify: eq = require(glsl-conditionals/when_eq);
#endif

void main() {
  #if defined(gridFade_output_fade)
    float end = eq(fract(gridFade_stepNow/passes), 0.0);

    #if type == typeGauss
      vec4 to = blur(gridFade_states[0], gridFade_uv, gridFade_stateShape.xy,
        mix(axis.xy, axis.yx, end)*scale);
    #else
      float radius = scale/max(gridFade_stateShape.x, gridFade_stateShape.y);
      float aspect = gridFade_stateShape.x/gridFade_stateShape.y;

      vec4 to = vec4(blur(gridFade_uv, radius, aspect, chaos),
        /** @todo Can this extra tap be removed? */
        sampleFade(gridFade_uv).a);
    #endif

    gridFade_output_fade =
      mix(to, mix(to*(1.0+(expose*dt)), colorLo, fade*dt), end);
  #endif
}
